'use client';

function VideoLoadingIndicator({ message = '', className = '' }) {
    return (
        <div
            className={`absolute inset-0 flex items-center justify-center bg-black/50 ${className}`}>
            <div className="flex flex-col items-center space-y-2">
                <div className="size-8 animate-spin rounded-full border-2 border-white border-t-red-600"></div>
                <p className="text-sm text-white">{message}</p>
            </div>
        </div>
    );
}

export default VideoLoadingIndicator;
